import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogRecuperarPasswordComponent } from '../dialog-recuperar-password/dialog-recuperar-password.component';
import { AlertifyService } from '../services/alertify.service';
import { ApiauthService } from '../services/apiauth.service';

@Component({
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss'],
})
export class LoginComponent implements OnInit {
  public email: string = '';
  public password: string = '';
  public hide = true;
  public iswhaiting=false;

  constructor(
    public apiAuth: ApiauthService,
    public dialog: MatDialog,
    public router: Router,
    private alertify: AlertifyService
  ) {
    var usr = this.apiAuth.usuarioData;
    if (usr) {
      if (usr.logueado) {
        this.router.navigate(['in']);
      }
    }
  }

  ngOnInit(): void {}

  login() {
    //  console.log(this.email);
this.iswhaiting=true;
    this.apiAuth.login(this.email, this.password).subscribe(
      (response) => {
        console.log(response);
        if (response.estadoLogin==1) {
          this.router.navigate(['in']);
        }
        else if(response.estadoLogin==0){
          this.alertify.error('Error en email o contraseña');
          this.iswhaiting=false;
        }
        else if(response.estadoLogin==2){
          this.alertify.error('Error, comuníquese con la liga');
          this.iswhaiting=false;
        }
      },
      (err) => {
        // console.log(err.error);
        this.alertify.error(err.error);
        this.iswhaiting=false;
      }
    );
  }
  recordarPassword() {
    console.log('recordar password');
    this.openDialog();
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(DialogRecuperarPasswordComponent);
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
    });
  }
}
